import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import {
    ListarTodosStatusEscrituraController,
    SalvarStatusEscrituraVendaController,
} from "../../../../../../Controllers/Cobranca/StatusEscritura/StatusEscrituraControllers";
import useArrayState from "../../../../../../hooks/useArrayState";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { IStatusEscritura } from "../../../../../../Interfaces/Cobranca/StatusEscritura/StatusEscrituraInterfaces";
import IconOrSpinner from "../../../../../Utils/IconOrSpinner";
import OrSpinner from "../../../../../Utils/OrSpinner";
import MegaOption from "../../../../Forms/MegaOption";

interface IEditarStatusEscrituraProps {
    then: Function;
    lstIdsEscritura: number[];
}

export default function EditarStatusEscritura(
    props: IEditarStatusEscrituraProps
) {
    const { value: listaCompletaStatusEscritura, loading } = useAsyncEffect(
        ListarTodosStatusEscrituraController,
        []
    );

    const { ID_CASO } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const [lstIdsStatusEscrituraSalvar, setIdsLstStatusEscrituraSalvar] =
        useArrayState({
            initialValue: props.lstIdsEscritura,
        });

    const {
        execute: handleSalvarStatusEscrituraButtonClick,
        loading: editando,
    } = useAsyncCallback(async () => {
        const lstObjetoStatusEscritura = lstIdsStatusEscrituraSalvar.map(
            (id) =>
                ({
                    Codigo: id,
                    Descricao: listaCompletaStatusEscritura!.find(
                        (se) => se.Codigo === id
                    )?.Descricao,
                } as IStatusEscritura)
        );
        await SalvarStatusEscrituraVendaController(
            ID_CASO,
            lstObjetoStatusEscritura
        ).then(() => {
            ReloadHistorico();
            props.then();
        });
    });

    return (
        <OrSpinner spinner="erp" loading={loading}>
            <div className="d-flex flex-wrap g-2">
                {listaCompletaStatusEscritura?.map((se) => (
                    <MegaOption
                        type="checkbox"
                        wrapperClassName="flex-grow-1"
                        inline
                        value={se.Codigo}
                        title={se.Descricao}
                        key={se.Codigo}
                        checked={lstIdsStatusEscrituraSalvar.some(
                            (x) => x === se.Codigo
                        )}
                        onChange={(e) => {
                            if (e.target.checked)
                                setIdsLstStatusEscrituraSalvar.add(se.Codigo);
                            else
                                setIdsLstStatusEscrituraSalvar.remove(
                                    se.Codigo
                                );
                        }}
                    />
                ))}
            </div>
            <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center g-2 mt-3"
                onClick={handleSalvarStatusEscrituraButtonClick}
                disabled={editando}
            >
                <IconOrSpinner
                    icon={faEdit}
                    loading={editando}
                    loadingSize="sm"
                />
                Atualizar
            </button>
        </OrSpinner>
    );
}
